import script from "./NavbarView.vue?vue&type=script&setup=true&lang=js"
export * from "./NavbarView.vue?vue&type=script&setup=true&lang=js"

import "./NavbarView.vue?vue&type=style&index=0&id=2c8cb796&lang=scss&scoped=true"
import "./NavbarView.vue?vue&type=style&index=1&id=2c8cb796&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c8cb796"]])

export default __exports__